import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { VTableModule } from "@app/directives/_layout/v-table/v-table.module";
import { MapDirectivesModule } from "@app/directives/_map/_map.directives.module";
import { ResourceFiltersDirectivesModule } from "@app/directives/_resourceFilters/_resourceFilters.directives.module";
import { ResourceManagementModule } from "@app/main/components/resourceManagement/resourceManagement.module";
import { CommserverMigration } from "@app/main/modules/foundation/_routes/rv-lite/commserver-migration/commserver-migration.component";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { VehicleDirectivesModule } from "../../../../../directives/_vehicle/_vehicle.directives.module";
import { FoundationComponentsModule } from "../../_components/components.modules";
import { CommissionModule } from "../commissions/commission.module";
import { AppEditorComponent } from "./application/_components/application-editor/application-editor.component";
import { ApplicationManagerComponent } from "./application/_components/application-manager/application-manager.component";
import { CameraConfigurationComponent } from "./camera-config/camera-configuration.component";
import { ConfigEditorComponent } from "./config/_components/config-editor/config-editor.component";
import { ConfigManagerComponent } from "./config/_components/config-manager/config-manager.component";
import { RVLiteComponent } from "./rv-lite.component";

const privateComponents: any[] = [
];

const publicComponents: any[] = [
    RVLiteComponent,
    ConfigManagerComponent,
    ConfigEditorComponent,
    ApplicationManagerComponent,
    AppEditorComponent,
    CameraConfigurationComponent,
    CommserverMigration
];

const declarations: any[] = [
];

const providers: any[] = [

];

@NgModule({
    imports: [
        CommonModule,
        PipesModule,
        FormsModule,
        FormsDirectivesModule,
        ReactiveFormsModule,
        VeriDirectivesModule,
        VehicleDirectivesModule,
        MiscDirectivesModule,
        LayoutDirectivesModule,
        CoreDirectivesModule,
        VTableModule,
        ResourceFiltersDirectivesModule,
        ResourceManagementModule,
        FoundationComponentsModule,
        MapDirectivesModule,
        CommissionModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class RVLiteModule {
    constructor() {
    }
}
